<template>
  <svg
    height="44"
    viewBox="0 0 44 44"
    width="44"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="m21.8603 43.7207c8.821 0 16.417-5.226 19.871-12.752h-39.742c3.454 7.526 11.049 12.752 19.871 12.752"
        fill="#ce1126"
      />
      <path
        d="m21.8603 0c-8.822 0-16.417 5.228-19.871 12.753h39.742c-3.454-7.525-11.05-12.753-19.871-12.753"
        fill="#fff"
      />
      <path
        d="m0 21.8614c0 3.253.714 6.335 1.989 9.107h39.742c1.274-2.772 1.99-5.854 1.99-9.107s-.716-6.336-1.99-9.108h-39.742c-1.275 2.772-1.989 5.855-1.989 9.108"
        fill="#0038a8"
      />
      <path
        d="m26.6557 9.1817h-19.062c-.278 3.907-.721 7.852-.27 11.771.29 2.583 1.078 5.162 2.559 7.33 1.768 2.622 4.429 4.516 7.244 5.882 2.81-1.378 5.472-3.26 7.242-5.882 1.48-2.168 2.27-4.747 2.559-7.33.449-3.919 0-7.864-.272-11.771"
        fill="#fff"
      />
      <path
        d="m8.0488 9.7774h18.153c.26 3.721.685 7.478.26 11.207-.278 2.465-1.027 4.918-2.437 6.98.194-1.097-.544-2.23-1.601-2.553-.826-.273-1.801-.051-2.41.592-.327-.858-.987-1.619-1.881-1.918-.008-1.154 0-2.304 0-3.456.466-.009.937 0 1.402 0 1.133.013 2.247.222 3.356.427-.33-.926-.33-1.943-.009-2.872-1.072.205-2.161.408-3.258.427-.49.016-.981 0-1.474.016-.025-.784-.025-1.56-.007-2.334 1.26-.01 2.509.193 3.737.435-.32-.929-.32-1.944.013-2.874-1.241.241-2.49.464-3.76.427-.008-1.213.206-2.407.437-3.595-.937.32-1.953.32-2.891 0 .232 1.188.448 2.382.438 3.595-1.269.037-2.517-.186-3.757-.427.33.93.321 1.945.011 2.874 1.237-.23 2.486-.471 3.756-.427-.028.778.016 1.552-.028 2.326-.49-.016-.982 0-1.471-.016-1.098-.019-2.187-.222-3.26-.427.319.929.319 1.946-.007 2.872 1.568-.319 3.159-.508 4.756-.414-.009 1.147.01 2.289 0 3.443-.743.254-1.358.816-1.694 1.511-.064.138-.111.281-.19.407-.625-.663-1.643-.876-2.489-.565-1.01.35-1.707 1.464-1.519 2.526-1.408-2.062-2.158-4.515-2.435-6.98-.427-3.729-.01-7.486.259-11.207"
        fill="#ce1126"
      />
      <path
        d="m15.6787 10.6866c.938.32 1.954.32 2.891 0-.231 1.187-.445 2.382-.436 3.595 1.269.037 2.518-.186 3.759-.427-.333.93-.333 1.945-.013 2.874-1.228-.242-2.477-.445-3.737-.436-.018.775-.018 1.551.007 2.334.493-.015.984 0 1.474-.015 1.097-.019 2.186-.222 3.259-.427-.322.929-.322 1.945.008 2.872-1.108-.205-2.223-.414-3.356-.428-.465 0-.936-.008-1.401 0 0 1.153-.009 2.303 0 3.456-.642-.235-1.375-.235-2.017 0 .01-1.153-.009-2.295 0-3.442-1.597-.095-3.188.095-4.756.414.326-.927.326-1.943.007-2.872 1.073.205 2.162.408 3.26.427.489.015.981 0 1.471.015.044-.773 0-1.547.028-2.325-1.27-.044-2.519.197-3.756.427.31-.929.319-1.944-.011-2.874 1.24.241 2.488.464 3.757.427.01-1.213-.206-2.408-.438-3.595"
        fill="#fff"
      />
      <path
        d="m16.1167 24.085c.642-.235 1.375-.235 2.017 0 .893.3 1.553 1.061 1.88 1.918.609-.643 1.584-.864 2.41-.592 1.057.323 1.795 1.456 1.601 2.553-1.687 2.499-4.225 4.292-6.898 5.603-2.679-1.3-5.215-3.104-6.902-5.603-.188-1.062.509-2.176 1.519-2.525.846-.312 1.864-.099 2.489.564.079-.126.126-.269.19-.406.336-.696.951-1.258 1.694-1.512"
        fill="#0038a8"
      />
    </g>
  </svg>
</template>
